/**
 * The server's field errors that belong to no field on screen: shown above the fields of a form in steps.
 * An error on a row of a fieldset (`dates.1.start_date`) belongs to its fieldset (`dates`), shown on that row.
 */
export function errorsElsewhere<T>(errors: Record<string, T>, fieldsOnScreen: { field_name: string }[]): [string, T][] {
    const names = new Set(fieldsOnScreen.map(field => field.field_name));
    return Object.entries(errors).filter(([field]) => !names.has(field.split(".")[0]));
}
